import { FC } from 'react';

import Alert from '@mui/material/Alert/Alert';

import useDefaultSettings from '../hooks/useDefaultSettings';

type WarningMessageProps = {
  settings: ReturnType<typeof useDefaultSettings>;
};

const WarningMessage: FC<WarningMessageProps> = ({ settings }) => {
  let message = 'Warning: To proceed with checkout, you need to ';

  if (!settings.defaultSettings.in_customer_id) {
    message += 'create or select an existing customer instance';
  }

  if (
    !settings.defaultSettings.in_customer_id &&
    !settings.defaultSettings.shipping_profile_id
  ) {
    message += ' and ';
  }

  if (!settings.defaultSettings.shipping_profile_id) {
    message += 'create a shipping profile';
  }

  message += '.';

  return <Alert color='warning'>{message}</Alert>;
};

export default WarningMessage;
